/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { constants } from '@well/infra/constants';

@Directive({
  selector: '[wellSameTimeLimit]',
  providers: [{ provide: NG_VALIDATORS, useExisting: SameTimeLimitValidator, multi: true }],
  standalone: true,
})
export class SameTimeLimitValidator implements Validator {
  validate(control: AbstractControl): { [key: string]: any } {
    return _sameTimeLimitValidator(control) ?? {};
  }
}

export const sameTimeLimitValidator = (): ValidatorFn => {
  return _sameTimeLimitValidator;
};

const _sameTimeLimitValidator = (
  control: AbstractControl<
    {
      paymentTimeLimit: number | null;
    }[]
  >
): ValidationErrors | null => {
  if (control) {
    const value = control.value;
    if (value && Array.isArray(value)) {
      return samePaymentTimeLimitValidatorFunction(value);
    }
    return null;
  }
  return null;
};

export const samePaymentTimeLimitValidatorFunction = (value: { paymentTimeLimit: number | null }[]) => {
  const uniquePaymentTimeLimitItemsNumber = value
    .filter((item) => item.paymentTimeLimit)
    .map((item) => item.paymentTimeLimit)
    .reduce((acc: number[], curr) => {
      if (curr && acc.indexOf(curr) === -1) acc.push(curr);
      return acc;
    }, []).length;

  if (uniquePaymentTimeLimitItemsNumber > 1) {
    return { [constants.validationErrorsKeys.differentTimeLimitError]: true };
  } else {
    return null;
  }
};
